import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  hasLines: boolean;
  nextStepUrl: string;
}

export default function ToCheckout(props: IProps) {
  const { t } = useTranslation();

  const onClick = useCallback(
    () => (window.location.href = props.nextStepUrl),
    [props.nextStepUrl]
  );

  return (
    <div className="flex justify-end mt-4">
      <button
        type="button"
        className="btn btn-primary w-full tablet:w-64"
        disabled={!props.hasLines}
        onClick={onClick}>
        {t('ToContinue')}
      </button>
    </div>
  );
}
